module.exports = __webpack_public_path__ + "static/media/Cabs2.0-225-100-A.1cb3d988.png";